import {appendQueryString} from "@pg-mono/request";

type IPageQuery = {} | {page: number};

export const generatePrevNextMetaLinks = (
    parsedPage: number,
    maxPage: number,
    fullUrl: string,
    restQuery: Record<string, string | string[]>,
    buildPageUrl: (pageQuery: IPageQuery) => string = (pageQuery) => appendQueryString(appendQueryString(fullUrl, restQuery), pageQuery)
) => {
    // getPrevPage has this strange type syntax on purpose (didnt work otherwise)
    const getPrevPage: (page: number) => IPageQuery = (p: number) => (p <= 2 ? {} : {page: p - 1}); // do not add `page` param to first page link
    const prev = parsedPage === 1 ? undefined : buildPageUrl(getPrevPage(parsedPage));
    const next = parsedPage < maxPage ? buildPageUrl({page: parsedPage + 1}) : undefined;

    return {
        prev,
        next
    };
};
import {appendQueryString} from "@pg-mono/request";

type IPageQuery = {} | {page: number};

export const generatePrevNextMetaLinks = (
    parsedPage: number,
    maxPage: number,
    fullUrl: string,
    restQuery: Record<string, string | string[]>,
    buildPageUrl: (pageQuery: IPageQuery) => string = (pageQuery) => appendQueryString(appendQueryString(fullUrl, restQuery), pageQuery)
) => {
    // getPrevPage has this strange type syntax on purpose (didnt work otherwise)
    const getPrevPage: (page: number) => IPageQuery = (p: number) => (p <= 2 ? {} : {page: p - 1}); // do not add `page` param to first page link
    const prev = parsedPage === 1 ? undefined : buildPageUrl(getPrevPage(parsedPage));
    const next = parsedPage < maxPage ? buildPageUrl({page: parsedPage + 1}) : undefined;

    return {
        prev,
        next
    };
};
